interface CardProps {
  cardBottom?: JSX.Element;
  children: JSX.Element;
  cardHeader?: JSX.Element;
}
const Card = ({ cardBottom, children, cardHeader }: CardProps) => {
  return (
    <div className={`w-full bg-white shadow  rounded-2xl h-auto border`}>
      {cardHeader}
      <div className="p-4 ">{children}</div>
      {cardBottom}
    </div>
  );
};

export default Card;
